<template>
  <div>
    <div class="title-sy"><span style="border-bottom: 1px solid rgb(124, 185, 186);">酒店分布示意图</span><p class="el-title-sub">陌上酒店已形成“以点连线，全国化”的酒店网络布局，酒店大多数位于市场潜力巨大的新一线城市和二三线城市。</p></div>
    <div id="mapCharts" style="width: 100%; height: 80%;">
<!--      <main-plugin  :img-src="imgMapSrc"></main-plugin >-->
      <img :src="imgMapSrc"  style="width:60%; height:100%">
    </div>
<!--    <el-row>
      <el-col :span="24" style="text-align: center">
        <div id="mapCharts" style="width: 100%; height: 500px;"></div>

      </el-col>
    </el-row>-->
  </div>
</template>

<script>
require("echarts/map/json/china.json");
export default {
  name: "MapPlugin",
  data() {
    return {
      //imgMapSrc: require('../assets/images/map_cs.png')
      imgMapSrc: require('../assets/images/map_cs01.png')
    }
  },
  mounted() {
    // this.initMap()
  },
 /* methods: {
    initMap() {
      let option = {
        geo: {
          map: "china",
          scaleLimit: {
            min: 1,
            max: 2
          },
          zoom: 1,
          top: 60,
          label: {
            normal: {
              show: true,
              fontSize: "12",
              color: "rgba(0,0,0,0.7)"
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#45b9b6',//默认区域颜色
              borderColor: '#fff'
            }
          }
        },
      }
      let mycharts = this.$echarts.init(document.getElementById("mapCharts"))
      mycharts.setOption(option)
    }
  }*/
}
</script>

<style scoped>

</style>
